import toArray from 'rc-util/lib/Children/toArray';
export function getPathValue(record, path) {
  // Skip if path is empty
  if (!path && typeof path !== 'number') {
    return record;
  }

  var pathList = toArray(path);
  var current = record; // tslint:disable-next-line:prefer-for-of

  for (var i = 0; i < pathList.length; i += 1) {
    if (!current) {
      return null;
    }

    var prop = pathList[i]; // @ts-ignore

    current = current[prop];
  }

  return current;
}
export function extractMatrixHeader(record, index, getRecordKey, getClassName, labelRender, labelIndex) {
  return {
    key: 'header',
    type: 'header',
    value: labelRender(getPathValue(record, labelIndex), record, index)
  };
}
export function extractMatrixValue(records, indices, getRecordKey, getClassName, dataRender, dataIndex) {
  var aKey = getRecordKey(records[0], indices[0]);
  var bKey = getRecordKey(records[1], indices[1]);
  var isBlank = aKey === bKey;
  var matrixValue = {
    key: "".concat(aKey, "-").concat(bKey),
    dataKeys: {
      row: aKey,
      col: bKey
    },
    type: isBlank ? 'blank' : 'value',
    value: null
  };

  if (!isBlank) {
    var values = records.map(function (r) {
      return getPathValue(r, dataIndex);
    });
    matrixValue.className = getClassName(values, records, indices);
    matrixValue.value = dataRender(values, records);
  }

  return matrixValue;
}
export function findParentElement(el, find) {
  var response = null;

  if (el) {
    var match = find(el);

    if (match) {
      response = el;
    } else {
      response = findParentElement(el.parentElement, find);
    }
  }

  return response;
}